import { selectors } from 'state/selectors';
import { buildTieringRequestWith } from './buildTieringRequest';

export const buildTieringRequest = buildTieringRequestWith(selectors);
